import TestPackageModel from "@/models/lab/TestPackageModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestPackageCollection extends LabServiceCollection {
  model() {
    return TestPackageModel;
  }

}
